import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { CosignMetaBody, UUID } from "@/core/types";

import { addendumKeys } from "../keyFactory";
import { getNoteAddendumCosignDetails } from "../queryFunctions/getNoteAddendumCosignDetails";

type UseNoteAddendumCosignDetailsProps<TData = CosignMetaBody> = {
  addendumId: UUID;
  enabled?: boolean;
  select?: (data: CosignMetaBody) => TData;
};

type NoteAddendumCosignDetailsQueryOptions = UseQueryOptions<
  CosignMetaBody,
  unknown,
  CosignMetaBody,
  ReturnType<typeof addendumKeys.cosignDetails>
>;

export function useNoteAddendumCosignDetails<TData = CosignMetaBody>({
  addendumId,
  enabled,
  select,
}: UseNoteAddendumCosignDetailsProps<TData>) {
  return useQuery({ ...optionFactory(addendumId, enabled), select });
}

function optionFactory(addendumId: UUID, enabled = true) {
  return {
    enabled,
    queryFn: () => getNoteAddendumCosignDetails(addendumId),
    queryKey: addendumKeys.cosignDetails(addendumId),
  } satisfies NoteAddendumCosignDetailsQueryOptions;
}
